import {createRenderer} from 'fela';
import {isDevelopment} from '@core/lib/environment';

export const createFelaRenderer = () =>
  createRenderer({
    devMode: isDevelopment,
    plugins: [],
    enhancers: [],
  });
